import Alert from 'common/components/core/Alert'
import {
  getNotificationCookie,
  removeNotificationCookie,
} from 'publisher/utils/cookie'
import React, { useEffect, useState } from 'react'

function Notification() {
  const [notification, setNotification] = useState('')

  useEffect(() => {
    const message = getNotificationCookie()
    if (message) {
      setNotification(message)
    }
    removeNotificationCookie()
  }, [])

  return notification ? (
    <Alert type="error" onClose={removeNotificationCookie}>
      {notification}
    </Alert>
  ) : null
}

export default Notification
